import { FullPageSpinner } from 'app/common/daisy/full-page-spinner';
import ToolEditor from '../tool-editor';
import type { ToolRunEditProps } from './tool-edit-run-hook';

export const ToolEditRun = (props: ToolRunEditProps) => {
  const { runEditOpen, closeModal, runEditToolName, hasPendingChanges } = props;

  const loading = false;

  let content: React.ReactNode;
  if (loading) {
    content = <FullPageSpinner />;
  } else {
    content = (
      <div className="flex flex-1 min-h-0">
        {/* Left Column - Tool Editor */}
        <div className="flex-1 border-r border-base-300 pr-4 flex flex-col">
          <ToolEditor toolName={runEditToolName ?? undefined} />
        </div>

        {/* Right Column - Tool Preview */}
        {/* <div className="flex-1 pl-4 flex flex-col">
          <div className="flex items-center gap-2 justify-between mb-2">
            <span className="font-semibold text-md text-nowrap">Run Tool</span>
            <button type="button" className={`btn`} onClick={() => {}}>
              Run
            </button>
          </div>

          <div className="flex-1 bg-base-200 rounded-lg p-4 overflow-auto min-h-0">
            <div className="text-sm">
              <p>Results will appear here when you run the tool.</p>
            </div>
          </div>
        </div> */}
      </div>
    );
  }

  return (
    runEditOpen && (
      <div className="modal modal-open">
        <div className="modal-box max-w-6xl w-11/12 h-5/6 max-h-none flex flex-col">
          <div className="overflow-scroll">{content}</div>
          <div className="modal-action mt-4">
            <button type="button" className="btn" onClick={closeModal} disabled={hasPendingChanges}>
              Close
            </button>
          </div>
        </div>
        <div className="modal-backdrop" onClick={closeModal} />
      </div>
    )
  );
};
